import React, {FC, useMemo} from "react";
import {FlexBox} from "@brg/ui";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {LongreadShopButtons} from "../../../components/LongreadShopButtons";
import {ShopCard} from "../../Shop/ShopCard";
import {useGetLongreadProducts} from "../../../hooks/api/Shop/useGetLongreadProducts";
import {bProfile} from "../../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import {ModerationType} from "../../teams/const/ModerationTypes";

interface PSShopProps {
    project: any
}

const ShopTitle = styled.div`
  color: ${({theme}) => theme.projectView.titleColor};
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; 
  letter-spacing: -0.02em;
`

export const PSShop: FC<PSShopProps> = ({project}) => {

    const { t } = useTranslation();
    const [products] = useGetLongreadProducts(project?.longreadId || "");
    const profile = useProfile();
    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isSuperModer(profile)), [profile]);

    const shouldVisibleShop = useMemo(() => {
        if (!project && !project?.teams) return false;
        if (project?.teams?.length === 0) return false;
        return project?.teams?.[0]?.teamId && [ModerationType.Own, ModerationType.OwnWithoutTag]?.includes(project?.teams?.[0]?.moderationType);
    }, [project])

    if (!project || !shouldVisibleShop || products?.length === 0 || !isModer || project?.isBook) return null;

    return <FlexBox direction="column" directionMobile="column" gy={24} offsetTop={24}>
        <FlexBox justify="space-between">
            <ShopTitle>{t('shop.longread_products')}</ShopTitle>
            <LongreadShopButtons project={project} isBottomBlock/>
        </FlexBox>
        <FlexBox gx={24}>
            {products?.map((value: any, index: number) => (
                // @ts-ignore
                <ShopCard key={value?.entityId} id={value?.entityId} images={value?.images} name={value?.name} price={value?.price}/>
            ))}
        </FlexBox>
    </FlexBox>
}import React, {FC, useMemo} from "react";
import {FlexBox} from "@brg/ui";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {LongreadShopButtons} from "../../../components/LongreadShopButtons";
import {ShopCard} from "../../Shop/ShopCard";
import {useGetLongreadProducts} from "../../../hooks/api/Shop/useGetLongreadProducts";
import {bProfile} from "../../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import {ModerationType} from "../../teams/const/ModerationTypes";

interface PSShopProps {
    project: any
}

const ShopTitle = styled.div`
  color: ${({theme}) => theme.projectView.titleColor};
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; 
  letter-spacing: -0.02em;
`

export const PSShop: FC<PSShopProps> = ({project}) => {

    const { t } = useTranslation();
    const [products] = useGetLongreadProducts(project?.longreadId || "");
    const profile = useProfile();
    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isSuperModer(profile)), [profile]);

    const shouldVisibleShop = useMemo(() => {
        if (!project && !project?.teams) return false;
        if (project?.teams?.length === 0) return false;
        return project?.teams?.[0]?.teamId && [ModerationType.Own, ModerationType.OwnWithoutTag]?.includes(project?.teams?.[0]?.moderationType);
    }, [project])

    if (!project || !shouldVisibleShop || products?.length === 0 || !isModer || project?.isBook) return null;

    return <FlexBox direction="column" directionMobile="column" gy={24} offsetTop={24}>
        <FlexBox justify="space-between">
            <ShopTitle>{t('shop.longread_products')}</ShopTitle>
            <LongreadShopButtons project={project} isBottomBlock/>
        </FlexBox>
        <FlexBox gx={24}>
            {products?.map((value: any, index: number) => (
                // @ts-ignore
                <ShopCard key={value?.entityId} id={value?.entityId} images={value?.images} name={value?.name} price={value?.price}/>
            ))}
        </FlexBox>
    </FlexBox>
}